export default __webpack_public_path__ + "static/media/49.834fdec2.jpg";